import { IField } from '../../../types/my-types';
import { DataTypeOption } from '../FieldsSettings/FieldsSettingsTypes';

export const getFieldDataTypeAndConfig = (fields: IField[], fieldId: string) => {
  const field = fields.find((f) => f.id === fieldId);
  return {
    dataType: field?.data_type,
    dataTypeConfig: field?.data_type_config,
  };
};
export const formatDataTypeAndConfig = (
  dataType?: string,
  fieldDataTypeConfig?: DataTypeOption | null
) => {
  return {
    dataType,
    dataTypeConfig: fieldDataTypeConfig,
  };
};
